export default __webpack_public_path__ + "static/media/magnifier.7c131583.svg";